(function () {
  if (window.__nfPdpFsBar) return;
  window.__nfPdpFsBar = true;

  function formatMoney(cents) {
    // Tenta usar formatter global do tema; fallback "$X" ou "$X.XX"
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    if (window.LoopMiniConfig && window.LoopMiniConfig.moneyFormat) {
      var fmt = window.LoopMiniConfig.moneyFormat;
      var dollars = (cents / 100);
      var formatted = dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2);
      return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, formatted);
    }
    var v = (cents / 100);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function render(bar, cartTotalCents) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 7900;
    var deficit = Math.max(0, threshold - cartTotalCents);
    var progress = Math.min(100, (cartTotalCents / threshold) * 100);

    var heading = bar.querySelector('[data-nf-fs-heading]');
    var fill = bar.querySelector('[data-nf-fs-fill]');

    if (fill) fill.style.width = progress + '%';

    if (heading) {
      if (deficit <= 0) {
        heading.innerHTML = '<strong>🎉 You unlocked FREE SHIPPING!</strong>';
        bar.classList.add('nf-fs-bar--unlocked');
      } else {
        heading.innerHTML = 'Add <strong data-nf-fs-deficit>' + formatMoney(deficit) + '</strong> more for <strong>FREE SHIPPING</strong> 🚚';
        bar.classList.remove('nf-fs-bar--unlocked');
      }
    }
  }

  function refreshAll() {
    var bars = document.querySelectorAll('[data-nf-fs-bar]');
    if (!bars.length) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
        bars.forEach(function (bar) { render(bar, total); });
      })
      .catch(function () { /* silencioso */ });
  }

  // Debounce: o Empty cart dispara N× on:line-item:change + 1× cart:updated;
  // colapsa a rajada num único fetch /cart.js.
  var fsDebounce;
  function scheduleRefresh() {
    clearTimeout(fsDebounce);
    fsDebounce = setTimeout(refreshAll, 80);
  }

  // cart:updated         -> add ao cart (atc-hardened) e Empty cart (cart-drawer)
  // on:line-item:change  -> mudança de quantidade / remoção de item no drawer
  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('on:line-item:change', scheduleRefresh);

  // Refresh inicial pra garantir sync se cart mudou em outra aba (bfcache)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
